import { ChartDataSets } from 'chart.js';
import { useTypesStore } from '@/store';
import useUtils from '@/hooks/useUtils';

export type ChartData = {
	labels: string[];
	datasets: ChartDataSets[];
};

export default function useChart() {
	const typeStore = useTypesStore();
	const { arrayColumn } = useUtils();

	const colors = [
		['Indian Red', 'CD5C5C'],
		['Light Coral', 'F08080'],
		['Salmon', 'FA8072'],
		['Dark Salmon', 'E9967A'],
		['Light Salmon', 'FFA07A'],
		['Crimson', 'DC143C'],
		['Red', 'FF0000'],
		['Fire Brick', 'B22222'],
		['Dark Red', '8B0000'],
		['Pink', 'FFC0CB'],
		['Light Pink', 'FFB6C1'],
		['Hot Pink', 'FF69B4'],
		['Deep Pink', 'FF1493'],
		['Medium Violet Red', 'C71585'],
		['Pale Violet Red', 'DB7093'],
		['Light Salmon', 'FFA07A'],
		['Coral', 'FF7F50'],
		['Tomato', 'FF6347'],
		['Orange Red', 'FF4500'],
		['Dark Orange', 'FF8C00'],
		['Orange', 'FFA500'],
		['Gold', 'FFD700'],
		['Yellow', 'FFFF00'],
		['Dark Yellow', 'D8D802'],
		['Lemon Chiffon', 'C4A758'],
		['Light Goldenrod Yellow', 'CCCC4B'],
		['Papaya Whip', 'FFEFD5'],
		['Moccasin', 'FFE4B5'],
		['Peach Puff', 'FFDAB9'],
		['Pale Goldenrod', 'EEE8AA'],
		['Khaki', 'F0E68C'],
		['Dark Khaki', 'BDB76B'],
		['Lavender', 'E6E6FA'],
		['Thistle', 'D8BFD8'],
		['Plum', 'DDA0DD'],
		['Violet', 'EE82EE'],
		['Orchid', 'DA70D6'],
		['Fuchsia', 'FF00FF'],
		['Magenta', 'FF00FF'],
		['Medium Orchid', 'BA55D3'],
		['Medium Purple', '9370DB'],
		['Amethyst', '9966CC'],
		['Blue Violet', '8A2BE2'],
		['Dark Violet', '9400D3'],
		['Dark Orchid', '9932CC'],
		['Dark Magenta', '8B008B'],
		['Purple', '800080'],
		['Indigo', '4B0082'],
		['Slate Blue', '6A5ACD'],
		['Dark Slate Blue', '483D8B'],
		['Medium Slate Blue', '7B68EE'],
		['Green Yellow', 'ADFF2F'],
		['Chartreuse', '7FFF00'],
		['Lawn Green', '7CFC00'],
		['Lime', '00FF00'],
		['Lime Green', '32CD32'],
		['Pale Green', '98FB98'],
		['Light Green', '90EE90'],
		['Medium Spring Green', '00FA9A'],
		['Spring Green', '00FF7F'],
		['Medium Sea Green', '3CB371'],
		['Sea Green', '2E8B57'],
		['Forest Green', '228B22'],
		['Green', '008000'],
		['Dark Green', '006400'],
		['Yellow Green', '9ACD32'],
		['Olive Drab', '6B8E23'],
		['Olive', '808000'],
		['Dark Olive Green', '556B2F'],
		['Medium Aquamarine', '66CDAA'],
		['Dark Sea Green', '8FBC8F'],
		['Light Sea Green', '20B2AA'],
		['Dark Cyan', '008B8B'],
		['Teal', '008080'],
		['Aqua', '00FFFF'],
		['Cyan', '00FFFF'],
		['Light Cyan', 'E0FFFF'],
		['Pale Turquoise', 'AFEEEE'],
		['Aquamarine', '7FFFD4'],
		['Turquoise', '40E0D0'],
		['Medium Turquoise', '48D1CC'],
		['Dark Turquoise', '00CED1'],
		['Cadet Blue', '5F9EA0'],
		['Steel Blue', '4682B4'],
		['Light Steel Blue', 'B0C4DE'],
		['Powder Blue', 'B0E0E6'],
		['Light Blue', 'ADD8E6'],
		['Sky Blue', '87CEEB'],
		['Light Sky Blue', '87CEFA'],
		['Deep Sky Blue', '00BFFF'],
		['Dodger Blue', '1E90FF'],
		['Cornflower Blue', '6495ED'],
		['Medium Slate Blue', '7B68EE'],
		['Royal Blue', '4169E1'],
		['Blue', '0000FF'],
		['Medium Blue', '0000CD'],
		['Dark Blue', '00008B'],
		['Navy', '000080'],
		['Midnight Blue', '191970'],
		['Cornsilk', 'FFF8DC'],
		['Blanched Almond', 'FFEBCD'],
		['Bisque', 'FFE4C4'],
		['Navajo White', 'FFDEAD'],
		['Wheat', 'F5DEB3'],
		['Burly Wood', 'DEB887'],
		['Tan', 'D2B48C'],
		['Rosy Brown', 'BC8F8F'],
		['Sandy Brown', 'F4A460'],
		['Goldenrod', 'DAA520'],
		['Dark Goldenrod', 'B8860B'],
		['Peru', 'CD853F'],
		['Chocolate', 'D2691E'],
		['Saddle Brown', '8B4513'],
		['Sienna', 'A0522D'],
		['Brown', 'A52A2A'],
		['Maroon', '800000'],
		['White', 'FFFFFF'],
		['Snow', 'FFFAFA'],
		['Honeydew', 'F0FFF0'],
		['Mint Cream', 'F5FFFA'],
		['Azure', 'F0FFFF'],
		['Alice Blue', 'F0F8FF'],
		['Ghost White', 'F8F8FF'],
		['White Smoke', 'F5F5F5'],
		['Seashell', 'FFF5EE'],
		['Beige', 'F5F5DC'],
		['Old Lace', 'FDF5E6'],
		['Floral White', 'FFFAF0'],
		['Ivory', 'FFFFF0'],
		['Antique White', 'FAEBD7'],
		['Linen', 'FAF0E6'],
		['Lavender Blush', 'FFF0F5'],
		['Misty Rose', 'FFE4E1'],
		['Gainsboro', 'DCDCDC'],
		['Light Grey', 'D3D3D3'],
		['Silver', 'C0C0C0'],
		['Dark Gray', 'A9A9A9'],
		['Gray', '808080'],
		['Dim Gray', '696969'],
		['Light Slate Gray', '778899'],
		['Slate Gray', '708090'],
		['Dark Slate Gray', '2F4F4F'],
		['Black', '000000'],
	];

	const getRandomColors = (amount: number) => {
		const result: string[] = [];
		let tempColors = JSON.parse(JSON.stringify(colors));

		Array.from(Array(amount).keys()).forEach(() => {
			const index = Math.ceil(Math.random() * amount);
			const randomColor: string = tempColors[index][1];
			result.push(randomColor);
			delete tempColors[index];
			tempColors = tempColors.filter(() => true);
		});

		return result;
	};

	const setDataObject = (
		label: string,
		data: number[],
		color: string
	): ChartDataSets => {
		return {
			label,
			borderColor: color,
			fill: false,
			data,
		};
	};

	const getChartData = (
		data: Array<Record<string, any>>,
		type: string
	): ChartData => {
		const dataValues: Record<string, Array<number>> = {};
		const nameList = arrayColumn('name', data);
		const result: ChartDataSets[] = [];

		data.forEach((dt, int) => {
			dt[type.replace('-', '_')].forEach(
				(type: { name: string; amount: string }) => {
					const typeObject = typeStore.getTypeFromExpenseObject(
						type as any
					) ?? { name: null };
					const keyName = `${type.name} (${typeObject.name ?? ''})`;

					if (!dataValues[keyName]) {
						dataValues[keyName] = [];

						for (let i = 0; i < nameList.length; i++) {
							dataValues[keyName].push(0);
						}
					}

					dataValues[keyName][int] = +(
						+type.amount + +dataValues[keyName][int]
					).toFixed(2);
				}
			);
		});

		const randomColors = getRandomColors(Object.keys(dataValues).length);
		for (const [name, amountList] of Object.entries(dataValues)) {
			result.push(
				setDataObject(
					name,
					amountList,
					`#${randomColors.shift() ?? '78ed82'}`
				)
			);
		}

		return {
			labels: nameList,
			datasets: result,
		};
	};

	return { getChartData };
}
